import * as $ from "jquery";

type Promise = JQuery.PromiseBase<any, any, any, any, any, any, any, any, any, any, any, any>;
type Source = (...args: any[]) => Promise;

/**
 * runs specified action only once
 */
export const fetchOnce = <T extends Source>(action: T) => {
    let promise: Promise = null;
    let isCompleted = false;
    let actionResult: any;

    const result = ((...args: any[]) => {
        if (isCompleted) {
            return $.Deferred().resolve(actionResult).promise();
        }

        if (promise) {
            return promise;
        }
        const result = (promise = action(...args));
        promise
            .always(() => (promise = null))
            .done(response => {
                isCompleted = true;
                actionResult = response;
            });

        return result;
    }) as any;

    result.reset = () => {
        promise = null;
        isCompleted = false;
        actionResult = null;
    };

    return result as T & { reset: F };
};
